import React, { useEffect, useRef } from 'react';
import './Clients.css';

const Clients = () => {
  const clients = [
    '/images/clients/1.svg',
    '/images/clients/2.svg',
    '/images/clients/3.svg',
    '/images/clients/4.svg',
    '/images/clients/5.svg',
    '/images/clients/6.png'
  ];

  // Duplicate clients for seamless loop
  const duplicatedClients = [...clients, ...clients, ...clients];
  const scrollRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollPosition = 0;
    const scrollSpeed = 0.5; // Adjust speed (pixels per frame)

    const animate = () => {
      scrollPosition += scrollSpeed;
      
      // Reset position when we've scrolled one full set
      const singleSetWidth = scrollContainer.scrollWidth / 3;
      if (scrollPosition >= singleSetWidth) {
        scrollPosition = 0;
      }

      scrollContainer.style.transform = `translateX(-${scrollPosition}px)`;
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return (
    <section className="clients-section">
      <div className="clients-container">
        <div className="clients-label">
          <h3>Worked with</h3>
          <h3>brands and partners</h3>
        </div>
        <div className="clients-slider-wrapper">
          <div className="clients-slider" ref={scrollRef}>
            {duplicatedClients.map((client, index) => (
              <div key={index} className="client-logo-wrapper">
                <img 
                  src={client} 
                  alt={`Client Logo ${index + 1}`} 
                  className="client-logo" 
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
